import {
  Divider,
  FormControl,
  FormHelperText,
  FormLabel,
  Input,
  Modal,
  ModalClose,
  ModalDialog,
  Stack,
  Typography,
} from '@healthinal/ui';
import { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { ContactTracingPlaceDto } from '../../../../../api/generated/model';
import { FormActionButtons } from '../../../../../components/form/FormActionButtons.tsx';

interface FormValues {
  name: string;
}

export function CreateContactPatientContactPlaceDialog({
  open,
  onClose,
  currentContactPlaces,
}: {
  open: boolean;
  onClose: (contactPlace?: ContactTracingPlaceDto) => void;
  currentContactPlaces: ContactTracingPlaceDto[];
}) {
  const {
    register,
    reset,
    handleSubmit,
    formState: { errors, isDirty: isFormDirty },
  } = useForm<FormValues>({
    defaultValues: {
      name: '',
    },
  });

  useEffect(() => {
    if (open) {
      reset();
    }
  }, [open]);

  const handleOnClose = () => {
    reset();
    onClose();
  };

  return (
    <Modal open={open} onClose={handleOnClose}>
      <ModalDialog sx={{ width: 500 }}>
        <ModalClose />
        <Typography level={'h4'}>Kontakt Ort erstellen</Typography>
        <Divider />
        <form
          onSubmit={(event) => {
            event.stopPropagation();
            void handleSubmit((data) => {
              onClose({
                name: data.name,
              });
            })(event);
          }}>
          <Stack gap={2}>
            <FormControl error={!!errors.name}>
              <FormLabel>
                <Typography>Kontakt Ort *</Typography>
              </FormLabel>
              <Input
                {...register('name', {
                  required: true,
                  validate: (name) => !currentContactPlaces.some((place) => place.name === name),
                })}
              />
              {errors.name && (
                <FormHelperText>
                  {errors.name.type === 'required'
                    ? 'Kontakt Ort muss ausgefüllt werden'
                    : 'Kontakt Ort existiert bereits'}
                </FormHelperText>
              )}
            </FormControl>
            <FormActionButtons onAbortClick={handleOnClose} disableSubmit={!isFormDirty} />
          </Stack>
        </form>
      </ModalDialog>
    </Modal>
  );
}
